<template>
    <div class="phone-page" id="phone-page" @scroll="handleScroll">
      <!--<van-nav-bar title="标题" class="home-index" :class="isFixed? 'is-fixed': ''">-->
        <!--<template #title>-->
          <!--<div class="nav-img">-->
             <!--<img src="../../assets/phone/page/logo1.png">-->
             <!--<img src="../../assets/phone/page/logo2.png">-->
          <!--</div>-->
        <!--</template>-->
      <!--</van-nav-bar>-->
      <header-common :isFixed="isFixed"></header-common>
      <!--立即申请-->
      <div class="info" :style="{'height': screenBodyHeight-60 +'px' }">
        <div class="bg-img" :style="bgStyle">
          <img src="../../assets/phone/page/obj.png" :style="bgImgStyle">
        </div>
        <div class="content">
          <div class="info-txt">
            <p class="tt"><img src="../../assets/phone/page/logo_name.png"></p>
            <div class="sub-title">赋能信息部门，提升全院服务</div>
            <h3>医院信息工作好管家!</h3>
            <p :style="screenBodyHeight>700?{'font-size': '1em'}: {}">“医信管家”是医院信息管理和服务工作的一体化平台。</p>
            <p :style="screenBodyHeight>700?{'font-size': '1em'}: {}">包含工作计划、项目建设实施、运维管理、服务管理、评级评审服务等功能、覆盖规划设计、部署实施、服务运营、持续改进和监督管理等全生命周期阶段。</p>
            <p :style="screenBodyHeight>700?{'font-size': '1em'}: {}">通过强化对信息工作的目标管理、过程管控、环节记录、结果反馈，更便捷的实现科室协作、全院互动，让IT工作发挥更强效能，为全院提升服务质量、提高服务效率贡献力量。</p>
          </div>
          <div class="apply">
            <van-button type="primary" @click="applyHandle">立即申请</van-button>
          </div>
        </div>
      </div>
      <!--信息服务-->
      <div class="info-service">
         <div class="title">让信息服务更主动、更高效、更智能</div>
         <div class="info-list">
           <div class="list-one" v-for="item in infoServiceList" :key="item.imgurl" @click="gotoDetail(item.pageId)">
             <div class="left">
               <img :src="item.imgurl">
             </div>
             <div class="right">
               <p class="tt">{{item.title}}</p>
               <p class="txt">{{item.content}}</p>
             </div>
             <div class="clear"></div>
           </div>
         </div>
      </div>
      <!--随时随地移动工作-->
      <div class="move-work" :style="{'height': screenHeight-60 +'px' }">
        <div class="title">随时随地的移动工作</div>
        <div class="img-show">
          <img :src="phoneShow">
        </div>
        <div class="info-list">
          <div class="list-one" v-for="(item, index) in workList" :key="item.normalurl">
            <div class="left">
              <img :src="item.activeurl" v-if="currentIndex == index">
              <img :src="item.normalurl" @click="changeActive(item.title, index)" v-else>
            </div>
            <div class="right">
              <p class="tt">{{item.title}}</p>
              <p class="txt">{{item.content}}</p>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <!--医信管家的作用-->
      <div class="info-service">
        <div class="title">医信管家的特点</div>
        <div class="info-list">
          <div class="list-one" v-for="item in fourthPageInfo.itemList" :key="item.imgurl">
            <div class="left">
              <img :src="item.imgurl">
            </div>
            <div class="right">
              <p class="tt">{{item.title}}</p>
              <p class="txt">{{item.content}}</p>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <footer-common :fourthPageInfo="fourthPageInfo" :isShowTopBtn="isShowTopBtn"></footer-common>
    </div>
</template>

<script>
import headerCommon from "../common/headerCommon";
import footerCommon from "../common/footerCommon";
import $ from 'jquery';
export default {
    name: "phoneIndex",
    props: ['infoServiceList', 'workList','fourthPageInfo'],
    data () {
        return {
            screenBodyHeight: 0, //屏幕Body高度
            screenHeight: 0, //屏幕高度
            isFixed: false,
            phoneShow: require("../../assets/phone/page/app_img.png"),
            currentIndex: 0, //移动工作的当前索引
            isShowTopBtn: false
        };
    },
    components: {
        footerCommon,
        headerCommon
    },
    computed: {
        bgStyle () {
            if (this.screenBodyHeight < 600) {
                return {'float':'right'};
            }
        },
        bgImgStyle () {
            if (this.screenBodyHeight < 580 ) {
                return {'width':'70%'};
            }
            if (this.screenBodyHeight >= 580 && this.screenBodyHeight < 600) {
                return {'width':'90%'};
            }
        }
    },
    methods: {
        handleClick () {
            this.isShow = true;
        },
        handleScroll () {
            let that = this;
            this.$nextTick(()=>{
                // 设备/屏幕高度
                let scrollObj = document.getElementById('phone-page'); // 滚动区域
                if (scrollObj !== null) {
                    let scrollTop = scrollObj.scrollTop; // div 到头部的距离
                    if (scrollTop >0) {
                        that.isFixed = true;
                        that.isShowTopBtn = true;
                    } else {
                        that.isFixed = false;
                        that.isShowTopBtn = false;
                    }
                }
            });
        },
        applyHandle () {
            this.$router.push({path:"/registerPage"});
        },
        changeActive (title, index) {
            if (title === 'APP:') {
                this.phoneShow = require("../../assets/phone/page/app_img.png");
            } else if (title === '小程序:') {
                this.phoneShow = require("../../assets/phone/page/sm_program.png");
            } else if (title === '企业微信:') {
                this.phoneShow = require("../../assets/phone/page/qy_webchart.png");
            }
            this.currentIndex = index;
        },
        handleScrollTop () {
            $('#phone-page').animate({scrollTop: 0}, 500);
        },
        gotoDetail (id) {
            /*去信息服务详情*/
            this.$router.push({
                path: '/infoService',
                query: {
                    id: id
                }
            });
        }
    },
    mounted () {
        let that = this;
        this.$nextTick(()=> {
            that.screenBodyHeight = document.body.clientHeight;
            that.screenHeight = window.screen.height;
        });
        $(window).bind('resize',function () {
            that.screenBodyHeight = document.body.clientHeight;
            that.screenHeight = window.screen.height;
        });
        // window.addEventListener('scroll', this.handleScroll(), true);  // 监听（绑定）滚轮滚动事件
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll()); //  离开页面清除（移除）滚轮滚动事件
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/phone/page.vue